export default function modalScrollTop() {
  $(".ModalManager").animate({
    scrollTop: 0
  }, 500);
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/modalScrollTop', modalScrollTop);